<script>
import languagedata from "@wikimedia/language-data";
export default {
  name: "LanguageSelector",

  props: {
    /**
     * Array of language codes. This is the available set of
     * languages that this selector is aware of.
     * If not passed, all languages known to langaugedata library
     * will be used.
     */
    value: {
      type: Array,
      default: () => null,
    },

    /**
     * Search API URL for language search.
     */
    searchAPI: {
      type: String,
      default:
        "https://en.wikipedia.org/w/api.php?action=languagesearch&format=json&formatversion=2",
    },
  },

  data: () => ({
    searchQuery: "",
    searchResults: [],
  }),

  computed: {
    allLanguages: () => Object.keys(languagedata.getLanguages()),
    languages: (vm) => vm.value || vm.allLanguages,
    availableLanguages: () => languagedata.getLanguages(),
    searchResultsByScript: (vm) =>
      languagedata.getLanguagesByScriptGroup(vm.searchResults),
  },

  watch: {
    /**
     * @param {string} query
     */
    searchQuery: async function (query) {
      this.searchResults = await this.search(query);
    },
  },

  mounted: async function () {
    // Initialize with an empty search
    this.searchResults = await this.search();
  },

  methods: {
    /**
     * @param {string} [query]
     * @return {Promise<string[]>}
     */
    search: async function (query) {
      if (!query || query.trim().length === 0) {
        return this.languages;
      }

      // See if the search query is a language code
      const exactMatch = this.languages.filter(
        (code) => query.toLowerCase() === code.toLowerCase()
      );
      if (exactMatch.length) {
        return exactMatch;
      }

      const filterResults = this.languages.filter(
        (code) =>
          // Search using autonym
          languagedata
            .getAutonym(code)
            .toLowerCase()
            .includes(query.toLowerCase()) ||
          // Search using script name
          languagedata
            .getScript(code)
            .toLowerCase()
            .includes(query.toLowerCase())
      );
      if (filterResults.length) {
        return filterResults;
      }

      // We did not find anly results from client side search.
      // Attempt a search using the given search API
      if (this.searchAPI) {
        const searchApiResults = await this.searchWithAPI(this.searchQuery);
        // Remove the languages not known to this selector.
        return searchApiResults.filter((code) => this.languages.includes(code));
      }

      return [];
    },

    /**
     * @param {string} query
     * @return {Promise<string[]>}
     */
    searchWithAPI: function (query) {
      const apiURL = new URL(this.searchAPI);
      apiURL.searchParams.append("search", query);
      apiURL.searchParams.append("origin", "*");
      return fetch(apiURL.toString())
        .then((response) => response.json())
        .then((result) => Object.keys(result.languagesearch || {}));
    },
  },
  render() {
    return this.$scopedSlots.default({
      languages: this.languages,
      searchResults: this.searchResults,
      searchResultsByScript: this.searchResultsByScript,
      getAutonym: languagedata.getAutonym,
      isRtl: languagedata.isRtl,
      isKnown: languagedata.isKnown,
      getDir: languagedata.getDir,
      inputAttrs: {
        value: this.searchQuery,
      },
      inputEvents: {
        input: (e) => {
          this.searchQuery = e.target.value;
        },
        keydown: (e) => {
          if (e.keyCode === 13) {
            e.preventDefault();
            // handle enter
          }
        },
      },
    });
  },
};
</script>